<template>
    
    <section class="slider-section">
        <div class="first-slider">
          <div
            id="carouselExampleDark"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <ol class="carousel-indicators">
              <li
                data-bs-target="#carouselExampleDark"
                data-bs-slide-to="0"
                class="active"
              ></li>
              <li
                data-bs-target="#carouselExampleDark"
                data-bs-slide-to="1"
              ></li>
              <li
                data-bs-target="#carouselExampleDark"
                data-bs-slide-to="2"
              ></li>
            </ol>
            <div class="carousel-inner">
              <div class="carousel-item active bg-dark-gery">
                <div class="row d-flex align-items-center">
                  <div class="col d-none d-lg-flex justify-content-center">
                    <div class="">
                      <h3 class="h3 fw-light">Has just arrived!</h3>
                      <h1 class="h1">Huge Summer Collection</h1>
                      <p class="pb-3">
                        Swimwear, Tops, Shorts, Sunglasses &amp; much more...
                      </p>
                      <div class="">
                        <a
                          class="btn btn-dark btn-ecomm"
                          href="javascript:;"
                        >
                          Shop Now <i class="bx bx-chevron-right"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <img
                      src="assets/images/slider/04.png"

                      class="img-fluid"
                      alt="..."
                    />
                  </div>
                </div>
              </div>
              <div class="carousel-item bg-dark-gery">
                <div class="row d-flex align-items-center">
                  <div class="col d-none d-lg-flex justify-content-center">
                    <div class="">
                      <h3 class="h3 fw-light">
                        Hurry up! Limited time offer.
                      </h3>
                      <h1 class="h1">Women Sportswear Sale</h1>
                      <p class="pb-3">
                        Sneakers, Keds, Sweatshirts, Hoodies &amp; much more...
                      </p>
                      <div class="">
                        
                        <a
                          class="btn btn-dark btn-ecomm"
                          href="javascript:;"
                        >
                          Shop Now <i class="bx bx-chevron-right"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <img
                      src="assets/images/slider/05.png"
                      class="img-fluid"
                      alt="..."
                    />
                  </div>
                </div>
              </div>
              <div class="carousel-item bg-dark-gery">
                <div class="row d-flex align-items-center">
                  <div class="col d-none d-lg-flex justify-content-center">
                    <div class="">
                      <h3 class="h3 fw-light">Complete your look with</h3>
                      <h1 class="h1">New Men's Accessories</h1>
                      <p class="pb-3">
                        Watch &amp; Caps, Sunglasses, Bags &amp; much more...
                      </p>
                      <div class="">
                        
                        <a
                          class="btn btn-dark btn-ecomm"
                          href="javascript:;"
                        >
                          Shop Now <i class="bx bx-chevron-right"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <img
                      src="assets/images/slider/03.png"
                      class="img-fluid"
                      alt="..."
                    />
                  </div>
                </div>
              </div>
            </div>
            <a
              class="carousel-control-prev"
              href="#carouselExampleDark"
              role="button"
              data-bs-slide="prev"
            >
              
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Previous</span>
            </a>
            <a
              class="carousel-control-next"
              href="#carouselExampleDark"
              role="button"
              data-bs-slide="next"
            >
              
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Next</span>
            </a>
          </div>
        </div>
      </section>
</template>


<script>
    export default{
        name: "Slider",
    }
</script>


<style>

</style>